import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OrganizationList from './components/OrganizationList';
import HouseList from './components/HouseList';
import FamilyList from './components/FamilyList';
import FamilyDetails from './components/FamilyDetails';
import HouseDetails from './components/HouseDetails';
import OrganizationDetails from './components/OrganizationDetails';
import HouseLocation from './components/HouseLocation';
import OrganizationLocation from './components/OrganizationLocation';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import { AuthProvider } from './components/AuthContext.jsx';
import 'antd/dist/reset.css';
import PlanningDocumentList from './components/PlanningList.jsx';
import PlanningDetails from './components/PlanningDetails.jsx';
import AddPlanningForm from './components/AddPlanningForm.jsx';
import RoadList from './components/RoadList.jsx';
import RoadDetailsForm from './components/RoadDetailsForm.jsx';
import RoadMapPage from './components/RoadMapPage.jsx';
import Layout from './components/Layout'; // Import the Layout component
import HouseCharts from './components/HouseChart.jsx';
import OrganizationChart from './components/OrganizationChart.jsx';
import FamilyCharts from './components/FamilyChart.jsx';
import WardList from './components/WardList.jsx';
import MunToleList from './components/MunToleList.jsx';
import AddWard from './components/AddWard.jsx';
import AddToleForm from './components/AddTole.jsx';
import AddWardStaff from './components/AddWardStaff.jsx';
import AddPeopleRepresentative from './components/AddPeopleRepresentative.jsx';
import WardDetails from './components/WardDetails.jsx';
import { AddBirthForm } from './components/AddBirthForm.jsx';
import { AddDeathForm } from './components/AddDeathForm.jsx';
import { AddTransferForm } from './components/AddTransferForm.jsx';
import RegistrationList from './components/RegistrationList.jsx';
import { AddRegistrationForm } from './components/RegistrationForm.jsx';
import { InvoiceList } from './components/InvoiceList.jsx';
import { AddInvoice } from './components/InvoiceForm.jsx';
import MunicipalPage from './components/MunicipalPage.jsx';
import  {LocalArea}  from './components/LocalArea.jsx';
 // Import LandingPage

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Set LandingPage as the home route */}
          <Route path="/" element={<MunicipalPage />} />
          
          {/* Login route */}
          <Route path="/login" element={<Login />} />

          {/* Wrap all protected routes with Layout */}
          <Route path="/houseList" element={<ProtectedRoute element={HouseList} />} />
          <Route path="/organizationList" element={<ProtectedRoute element={OrganizationList} />} />
          
          <Route path="/familyList" element={<ProtectedRoute element={FamilyList} />} />
          <Route path="/family/:id/details" element={<ProtectedRoute element={FamilyDetails} />} />
          <Route path="/house/:id/details" element={<ProtectedRoute element={HouseDetails} />} />
          <Route path="/organization/:id/details" element={<ProtectedRoute element={OrganizationDetails} />} />
          <Route path="/houseLocation" element={<ProtectedRoute element={HouseLocation} />} />
          <Route path="/organizationLocation" element={<ProtectedRoute element={OrganizationLocation} />} />
          <Route path="/planningList" element={<ProtectedRoute element={PlanningDocumentList}/>} />
          <Route path="/planning/:id/details" element={<ProtectedRoute element={PlanningDetails}/>} />
          <Route path="/planning/add" element={<ProtectedRoute element={AddPlanningForm}/>} />
          <Route path="/roadList" element={<ProtectedRoute element={RoadList}/>} /> 
          <Route path="/road/:id/details" element={<ProtectedRoute element={RoadDetailsForm}/>} />
          <Route path="/all-road" element={<ProtectedRoute element={RoadMapPage}/>} /> 
          <Route path="/house-chart" element={<ProtectedRoute element={HouseCharts}/>} />
          <Route path="/organizationChart" element={<ProtectedRoute element={OrganizationChart}/>} />
          <Route path="/familyChart" element={<ProtectedRoute element={FamilyCharts}/>} />
          <Route path="/ward-list" element={<ProtectedRoute element={WardList}/>} />
          <Route path="/tole-list" element={<ProtectedRoute element={MunToleList}/>} />
          <Route path="/ward/add" element={<ProtectedRoute element={AddWard}/>} />
          <Route path="/tole/add" element={<ProtectedRoute element={AddToleForm}/>} />
          <Route path="/ward-staff/add" element={<ProtectedRoute element={AddWardStaff}/>} />
          <Route path="/people-representative/add" element={<ProtectedRoute element={AddPeopleRepresentative}/>} />
          <Route path="/ward/:id/details" element={<ProtectedRoute element={WardDetails}/>} />
          <Route path="/family/:id/details/add-death-form" element={<ProtectedRoute element={AddDeathForm}/>} />
          <Route path="/family/:id/details/add-birth-form" element={<ProtectedRoute element={AddBirthForm}/>} />
          <Route path="/family/:id/details/add-transfer-form" element={<ProtectedRoute element={AddTransferForm}/>} />
          <Route path="/registration-list" element={<ProtectedRoute element={RegistrationList}/>} />
          <Route path="/registration/add" element={<ProtectedRoute element={AddRegistrationForm}/>} />
          <Route path="/invoice-list" element={<ProtectedRoute element={InvoiceList}/>} />
          <Route path="/invoice/add" element={<ProtectedRoute element={AddInvoice}/>} />
          <Route path="/map-list" element={<ProtectedRoute element={LocalArea}/>} />
          
          {/* Add more routes here if needed */}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
